module.exports = __webpack_public_path__ + "static/media/SILKSERIF-BOLD.9273f5d0.woff2";